module.exports = __webpack_public_path__ + "img/40_67.bc1809d4.png";